import React from 'react';
import {
  TableRow, TableCell,
  ListItem, ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { getUIDateFormat, getEmptyValue } from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { compose } from 'recompose';
import { withChangeHandlers } from 'helpers/Change';

const AgentDeviceName = ({ agentDeviceName, handleChange }) => (
  <MUITextBox
    title="Agent Device Name"
    name="agentDeviceName"
    value={getEmptyValue(agentDeviceName)}
    onChange={handleChange}
    validators={['required', 'maxStringLength:225']}
    errorMessages={['Required Field', 'Maximum 225 characters allowed']}
  />
);

const Manufacturer = ({ manufacturer, handleChange }) => (
  <MUITextBox
    title="Manufacturer"
    value={getEmptyValue(manufacturer)}
    onChange={handleChange}
    name="manufacturer"
    validators={['required', 'maxStringLength:225']}
    errorMessages={['Required Field', 'Maximum 225 characters allowed']}
  />
);

const INDIdeHolder = ({ indIdeHolder, handleChange }) => (
  <MUISelect
    name="indIdeHolder"
    value={getEmptyValue(indIdeHolder)}
    onChange={handleChange}
    title="INDIdeHolder"
  >
    <ListItem button value="Industry">
      <ListItemText primary="Industry" />
    </ListItem>
    <ListItem button value="LPO">
      <ListItemText primary="LPO" />
    </ListItem>
    <ListItem button value="NCI">
      <ListItemText primary="NCI" />
    </ListItem>
    <ListItem button value="Other">
      <ListItemText primary="Other" />
    </ListItem>
  </MUISelect>
);

const IDENumber = ({ indIdeNumber, handleChange }) => (
  <MUITextBox
    title="IDE Number"
    value={getEmptyValue(indIdeNumber)}
    validators={indIdeNumber ? ['maxStringLength:50'] : []}
    errorMessages={['Maximum 50 characters allowed']}
    onChange={handleChange}
    name="indIdeNumber"
  />
);

const Status = ({ esysStatus, handleChange }) => (
  <MUISelect
    name="esysStatus"
    value={esysStatus || 'ACTIVE'}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    title="Status"
  >
    <ListItem button value="ACTIVE">
      <ListItemText primary="Active" />
    </ListItem>
    <ListItem button value="INACTIVE">
      <ListItemText primary="Inactive" />
    </ListItem>
  </MUISelect>
);

const StatusDate = ({
  esysStatusDate, handleDateChange
}) => (
  <MUIDatePicker
    title="Status Date"
    name="esysStatusDate"
    value={esysStatusDate ? getUIDateFormat(esysStatusDate) : ''}
    onChange={handleDateChange('esysStatusDate')}
  />
);

const IDEHolderName = ({ indIdeHolderName, handleChange }) => (
  <MUITextBox
    title="IDE Holder Name"
    value={getEmptyValue(indIdeHolderName)}
    validators={indIdeHolderName ? ['maxStringLength:225'] : []}
    errorMessages={['Maximum 225 characters allowed']}
    onChange={handleChange}
    name="indIdeHolderName"
  />
);

const EditIdeAgents = (props) => {
  const {
    state,
    cancel,
    reset,
    agentType,
    handleChange,
    handleDateChange
  } = props;

  const {
    agentDeviceName,
    manufacturer,
    indIdeHolder,
    indIdeHolderName,
    indIdeNumber,
    esysStatus,
    esysStatusDate,
    modifiedUser,
    modifiedDate
  } = state;

  return (
    <TableRow className="state">
      <TableCell>
        <AgentDeviceName
          agentDeviceName={agentDeviceName}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <Manufacturer
          manufacturer={manufacturer}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        {(agentType === 'IDE') ? (
          <INDIdeHolder
            indIdeHolder={indIdeHolder}
            handleChange={handleChange}
          />
        ) : indIdeHolder}
      </TableCell>
      <TableCell>
        {(agentType === 'IDE') ? (
          <IDEHolderName
            indIdeHolderName={indIdeHolderName}
            handleChange={handleChange}
          />
        ) : indIdeHolderName}
      </TableCell>
      <TableCell>
        {(agentType === 'IDE') ? (
          <IDENumber
            indIdeNumber={indIdeNumber}
            handleChange={handleChange}
          />
        ) : indIdeNumber}
      </TableCell>
      <TableCell>
        <Status
          esysStatus={esysStatus}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <StatusDate
          esysStatusDate={esysStatusDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>{modifiedUser || ''}</TableCell>
      <TableCell>{modifiedDate || ''}</TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>
  );
};


const EditIDEAgents = compose(withChangeHandlers)(EditIdeAgents);

export default EditIDEAgents;
